import React from "react";
import { BANNER_TYPE_COLORS, BANNER_TYPE_LABELS } from "../../core/constants";

function BannerTypeTag({ type, style = {} }) {
  const config = BANNER_TYPE_COLORS[type] || {
    color: "#404750",
    background: "#f5f5f5",
    border: "#d9d9d9",
  };
  const label = BANNER_TYPE_LABELS[type] || type;

  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 12px",
        borderRadius: "16px",
        fontSize: "12px",
        fontWeight: 500,
        color: config.color,
        background: config.background,
        border: `1px solid ${config.border}`,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {label}
    </span>
  );
}

export default React.memo(BannerTypeTag);
